define([
	"./_StateAction",
	"csi/def/ActionFactory"
], function(_StateAction,ActionFactory) {

	return ActionFactory.declare("Abandon", _StateAction, {
		// Role "Revision Approver" is needed, to be checked by server logic
		m_tag: "Abandon"
	});
});